import './App.css';
import { useEffect, useState } from 'react';
import WelcomeInstallModal from './common/welcome-install-modal';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import nProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createTheme, ThemeProvider } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PushNotifications from './component/PushNotifications';
import ConfigStore from './redux/store';
import { UserAction } from './redux/action';
import RouteNavigation from './router';
import './themes/colors.css';

const { store } = ConfigStore();
export const queryClient = new QueryClient();
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function App() {

  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  
  const isCustomerOrDealerTech =
    window.location.pathname.includes('customer') ||
    window.location.pathname.includes('dealer-technician');

  function hasSeenWelcomeModal() {
    return localStorage.getItem('welcomeModalSeen') === 'true';
  }
  function setWelcomeModalSeen() {
    localStorage.setItem('welcomeModalSeen', 'true');
  }

  const [showWelcome, setShowWelcome] = useState(() => {
    return isCustomerOrDealerTech && !isStandalone && !hasSeenWelcomeModal();
  });
  useEffect(() => {
    store.dispatch(UserAction.saveBranding());
    // const idHeader = 'header-privates';
    // const elProgress = document.getElementById(idHeader);
    // if (elProgress) {
    //   nProgress.configure({ parent: `#${idHeader}` });
    // }

    // nProgress.start();
    // setTimeout(() => {
    //     nProgress.done();
    // }, 2000);


    const { width, height } = window.screen;
    const htmlTag = document.getElementsByTagName('html')[0];
    const baseFontSize = 16;
    htmlTag.style.fontSize = Math.min(baseFontSize * (width / 1440), baseFontSize * (height / 900));
  }, []);

  const theme = createTheme({
    typography: {
      fontFamily: 'poppins'
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Elements stripe={stripePromise}>
        <Provider store={store}>
          <ToastContainer
            position="top-right"
            style={{ width: "calc(var(--fs-hero)*8.1132075)" }}
            toastStyle={{ width: "calc(var(--fs-hero)*8.1132075)", minWidth: "calc(var(--fs-hero)*8.1132075)" }}
          />
          <QueryClientProvider client={queryClient}>
            <div id="header-privates" className="App">
              <PushNotifications />
              <RouteNavigation />
              <WelcomeInstallModal
                open={showWelcome}
                onClose={() => {
                  setShowWelcome(false);
                  setWelcomeModalSeen();
                }}
              />
            </div>
          </QueryClientProvider>
        </Provider>
      </Elements>
    </ThemeProvider>
  );
}

export default App;
